import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useAppStore = defineStore('app', () => {
  // Store values from query params
  const view = ref<string>('standard');
  const prompt = ref<string>('answers');
  const welcomeMessage = ref<string>('Please use this page to ask a question.');

  // Function to update store from query params
  function updateFromQueryParams() {
    const urlParams = new URLSearchParams(window.location.search);
    view.value = urlParams.get('view') || 'standard';
    prompt.value = urlParams.get('prompt') || 'answers';
    welcomeMessage.value =
      urlParams.get('welcome') || 'Please use this page to ask a question.';
  }

  if (process.env.VUE_APP_NODE_ENV !== 'production') {
    // Listen for changes in query params
    window.addEventListener('popstate', updateFromQueryParams);
    window.addEventListener('pushstate', updateFromQueryParams);
    window.addEventListener('replacestate', updateFromQueryParams);

    // Initial load
    updateFromQueryParams();
  }

  return { view, prompt, welcomeMessage, updateFromQueryParams };
});
